import * as AssetDetailsActions from './asset-details.actions';
import {INITIAL_STATE, AssetDetailsState} from './asset-details.state';
import {AssetModelHelper, DateRangeHelper} from './asset-details.util';

export default (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case AssetDetailsActions.GET_ASSET_DATA: {
      const {asset = {}} = state;
      const refreshDataNeeded = payload === asset.id;
      const newState = refreshDataNeeded ? {...state} : new AssetDetailsState();
      return {
        ...newState,
        loading: !refreshDataNeeded,
        refreshing: refreshDataNeeded,
        error: undefined
      };
    }
    case AssetDetailsActions.GET_ASSET_DATA_SUCCESS: {
      const {selectedSeriesIds = []} = state;
      const asset = AssetModelHelper.updateFromJsonApi(state.asset, payload.data, payload.user, payload.included);
      const selected = selectedSeriesIds.length > 0 ? [...selectedSeriesIds] : asset.defaultChartedseriesIds;
      return {
        ...state,
        loading: false,
        refreshing: payload.moreData,
        asset: asset,
        selectedSeriesIds: selected
      };
    }
    case AssetDetailsActions.GET_ASSET_DATA_FAILED: {
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: 'Error while getting asset data. Please try again.'
      };
    }
    case AssetDetailsActions.SELECT_SERIES: {
      const {selectedSeriesIds = []} = state;
      return {
        ...state,
        selectedSeriesIds: selectedSeriesIds.includes(payload) ? selectedSeriesIds : [...selectedSeriesIds, payload]
      };
    }
    case AssetDetailsActions.DESELECT_SERIES: {
      const {selectedSeriesIds = [], asset = {}} = state;
      const {seriesData = {}} = asset;
      const {[payload]: omint, ...rest} = seriesData;
      const remaindSelected = selectedSeriesIds.filter(selectedId => selectedId !== payload);
      return {
        ...state,
        selectedSeriesIds: remaindSelected,
        asset: {...state.asset, seriesData: {...rest}}
      };
    }
    case AssetDetailsActions.SET_DATE_RANGE: {
      const [start, end] = payload;
      return {
        ...state,
        dataDateRange: DateRangeHelper.setByRange(start, end)
      };
    }

    case AssetDetailsActions.SET_DATE_RANGE_BY_OPTION: {
      return {
        ...state,
        dataDateRange: DateRangeHelper.setByOption(payload)
      };
    }
    case AssetDetailsActions.GET_SERIES_DATA: {
      const {selectedSeriesIds = [], dataDateRange = {}} = state;
      const {option = 1} = dataDateRange;
      //set loading to true if we have selected series.
      return {
        ...state,
        seriesDataStatus: {
          chartLoading: selectedSeriesIds.length > 0,
          valuesLoading: selectedSeriesIds.length > 0,
          error: undefined
        },
        dataDateRange: payload.updateDateRange ? DateRangeHelper.setByOption(option) : {...state.dataDateRange}
      };
    }
    case AssetDetailsActions.GET_SERIES_DATA_SUCCESS: {
      const {seriesData = {}} = state.asset;
      let currentSeriesData = {...seriesData};
      payload.seriesList.forEach(item => {
        const {data = [], series, rollup} = item;
        currentSeriesData = AssetModelHelper.addOrUpdateSeriesData(
          currentSeriesData,
          series,
          data,
          payload.dataFor,
          rollup
        );
      });
      const {seriesDataStatus = {}} = state;
      switch (payload.dataFor) {
        case 'chart': {
          seriesDataStatus.chartLoading = false;
          break;
        }
        case 'values': {
          seriesDataStatus.valuesLoading = false;
          break;
        }
        default: {
          seriesDataStatus.chartLoading = false;
          seriesDataStatus.valuesLoading = false;
        }
      }

      return {
        ...state,
        asset: {...state.asset, seriesData: currentSeriesData},
        seriesDataStatus: {...seriesDataStatus}
      };
    }
    case AssetDetailsActions.GET_SERIES_DATA_FAILED: {
      return {
        ...state,
        seriesDataStatus: {
          chartLoading: false,
          valuesLoading: false,
          error: 'Error loading timeseries data for this asset.'
        }
      };
    }
    case AssetDetailsActions.SET_ACTIVE_DATA_TAB: {
      return {
        ...state,
        activeDataTap: payload
      };
    }
    //action to update gps data on client side to make sure user will see same data between asset info and location tab info
    //until we update location tab to work of redux
    case AssetDetailsActions.UPDATE_ASSET_LOCATION: {
      const gpsSeries = state.asset.locationSeries || {};
      if (payload && gpsSeries.last && payload.t !== gpsSeries.last.t) {
        gpsSeries.last = payload;
      }
      return {
        ...state,
        asset: {...state.asset, locationSeries: gpsSeries}
      };
    }
    default:
      return state;
  }
};
